// extracted by mini-css-extract-plugin
export default {"p__container":"Attendees_p__container__NlcH-","p__rVieBtn":"Attendees_p__rVieBtn__Sgpsu"};